var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{class:_vm.warning ? 'text-warning' : _vm.value ? 'text-success' : 'text-danger',attrs:{"icon":['fas', _vm.warning ? 'exclamation' : _vm.value ? 'check' : 'times']}})}
var staticRenderFns = []

export { render, staticRenderFns }